import React from "react";
import Close from "./icons/Close";
import * as palette from "@govlaunch/palette";

export default function Clear({ ...props }) {
  return (
    <button
      type="button"
      aria-label="Clear"
      title="Clear"
      tabIndex={0}
      css={{
        ":focus": {
          color: palette.text,
        },
        marginLeft: "auto",
        cursor: "pointer",
        background: "none",
        border: 0,
        padding: 2,
        outline: 0,
        marginTop: 5,
        marginRight: 15,
        color: palette.sealBlue,
      }}
      {...props}
    >
      <Close width={10} height={10} />
    </button>
  );
}
